import React, { useState } from "react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import Modal from "@/components/Modal"
import { DataUktPendaftarLulus } from "@/types"
import { Loader2, MoreHorizontal } from "lucide-react"
import Form from "./FormUKT"
import { Label } from "@/components/ui/label"
import { Switch } from "@/components/ui/switch"
import FormHeader from "@/components/FormHeader"
import { MdModeEdit } from "react-icons/md"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import toast from "react-hot-toast"
import { AxiosError } from "axios"
import api from "@/lib/axios"

const postDataTitipan = async (newData: {
  id_data_ukt_pendaftar_lulus: string
  is_titipan: boolean
  is_show_genrate_surat_pernyataan: boolean
}) => {
  const response = await api.post(
    "/data-ukt-pendaftar-lulus/ubah-titipan-ukt",
    newData
  )
  return response.data
}

export default function Actions({ row }: { row: DataUktPendaftarLulus }) {
  const [showEdit, setShowEdit] = useState(false)
  const [showTitipan, setShowTitipan] = useState(false)
  const [selectedRow, setSelectedRow] = useState<DataUktPendaftarLulus | null>(
    null
  )
  const [form, setForm] = useState({
    is_titipan: selectedRow?.is_titipan ?? false,
    is_show_genrate_surat_pernyataan:
      selectedRow?.is_show_genrate_surat_pernyataan ?? false,
  })

  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: postDataTitipan,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["listDataUktPendaftarLulus"],
      })
      setShowTitipan(false)
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleSetTitipan = () => {
    mutate({
      id_data_ukt_pendaftar_lulus: row.id_data_ukt_pendaftar_lulus,
      is_titipan: form.is_titipan,
      is_show_genrate_surat_pernyataan: form.is_show_genrate_surat_pernyataan,
    })
  }

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowEdit(true)
                setSelectedRow(row)
              }}
            >
              Ubah UKT
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => {
                setShowTitipan(true)
                setSelectedRow(row)
              }}
            >
              Set Titipan
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Modal show={showEdit} onClose={() => setShowEdit(false)}>
        <Form closeModal={() => setShowEdit(false)} selectedRow={selectedRow} />
      </Modal>

      <Modal show={showTitipan} onClose={() => setShowTitipan(false)}>
        <FormHeader icon={<MdModeEdit />} title={"Form"} />
        <div className="flex flex-col gap-y-3">
          <div className="flex gap-3">
            <Switch
              id="status"
              checked={form.is_titipan}
              onCheckedChange={() =>
                setForm((prev) => ({
                  ...prev,
                  is_titipan: !prev.is_titipan,
                }))
              }
            />
            <Label htmlFor="status">Is Titipan</Label>
          </div>
          <div className="flex gap-3">
            <Switch
              id="status"
              checked={form.is_show_genrate_surat_pernyataan}
              onCheckedChange={() =>
                setForm((prev) => ({
                  ...prev,
                  is_show_genrate_surat_pernyataan:
                    !prev.is_show_genrate_surat_pernyataan,
                }))
              }
            />
            <Label htmlFor="status">Is Show Generate Surat Pernyataan</Label>
          </div>
        </div>
        <div className="mt-5 flex gap-3">
          <Button
            variant={"outline"}
            onClick={() => setShowTitipan(false)}
            disabled={isPending}
          >
            Batal
          </Button>
          <Button onClick={handleSetTitipan} disabled={isPending}>
            {isPending ? (
              <>
                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                Processing...
              </>
            ) : (
              "Simpan"
            )}
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  )
}
